import { useEffect, useState } from "react";
import { UnoStoreHooks, UiComponents } from "@simulanisindia/ui";
import EditorMain from "../editor/Editor";
import apiclient from "../../apiclient";
import { PROJECT_ACCESS, PROJECT_SHARE_LIST } from "../../apiclient/apiEndpoints";
import { useNavigate, useParams } from "react-router-dom";
import { redirectToUno } from "../../utils/common";

const { useUnoSelector } = UnoStoreHooks;
const { FullScreenLoader } = UiComponents;

const Preview = ({ isMobileView }) => {
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const getProjectShareList = async (_projectId) => {
    try {
      const { usersList } = await apiclient.get(`${configData?.config?.API_URL}${PROJECT_SHARE_LIST}/${_projectId}`);
      const currentUserUUID = userData?.user?.uuid;
      const currentGroupUUID = userData?.user?.group?.uuid;

      const hasAccess = usersList.some((user) => user.uuid === currentUserUUID || user.uuid === currentGroupUUID);
      if (!hasAccess) navigate("/");
    } catch (error) {
      console.error("Error fetching project", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProjectAccess = async () => {
    try {
      const response = await apiclient.get(`${configData?.config?.API_URL}${PROJECT_ACCESS}/${uuid}`);
      const isPublic = response?.access?.public;
      if (!isPublic) {
        if (userData?.token) {
          await getProjectShareList(uuid);
        } else {
          redirectToUno({ configData });
        }
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching", error);
    }
  };

  useEffect(() => {
    if (uuid) {
      fetchProjectAccess();
    }
  }, [uuid]);

  return loading ? (
    <FullScreenLoader loading={true} />
  ) : (
    <EditorMain
      isMobileView={isMobileView}
      showHeaderProps={false}
      showToolbarProps={false}
      updateSceneProps={false}
      showBackButton={false}
    />
  );
};

export default Preview;
